import { render } from "./Menu.vue?vue&type=template&id=15fee5aa&lang=pug"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"
script.render = render

export default script